import { z } from "zod/v4";
import { maxKg } from "../../../../booking-utils";

export const totalGrossWeightSchema = z
  .number()
  .refine((data) => data > 0, { message: "bookingV3.shipment.weightPieces.error.mandatoryWeight", path: ["totalGrossWeight"] })
  .refine((data) => data <= maxKg, { message: "bookingV3.shipment.weightPieces.error.maximumWeight", path: ["totalGrossWeight"] });

export const totalVolumeWeightSchema = z
  .number()
  .refine((data) => data > 0, { message: "bookingV3.shipment.weightPieces.error.mandatoryDimension", path: ["totalVolumeWeight"] })
  .refine((data) => data <= maxKg, { message: "bookingV3.shipment.weightPieces.error.maximumWeight", path: ["totalVolumeWeight"] });

export const perItemSchema = z.object({
  grossWeight: z
    .number()
    .refine((val) => val > 0, {
      message: "bookingV3.shipment.weightPieces.error.mandatoryWeight",
    })
    .refine((val) => val <= maxKg, {
      message: "bookingV3.shipment.weightPieces.error.maximumWeight",
    }),

  volumeWeight: z
    .number()
    .refine((val) => val > 0, {
      message: "bookingV3.shipment.weightPieces.error.mandatoryDimension",
    })
    .refine((val) => val <= maxKg, {
      message: "bookingV3.shipment.weightPieces.error.maximumWeight",
    }),
});
